module.exports = __webpack_public_path__ + "static/2front-spirit-1-6b744c5ccc09a7dd8bde19ecc166697b.png";